import * as React from "react";
import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import { Link } from "react-router-dom";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Sidebar from "../../components/SidebarList/Index";
import { useAuth } from "../../services/AuthContext";

const drawerWidth = 250;

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(8),
      },
    }),
  },
}));

export default function AppSideBar({ open, classes, toggleDrawer }) {
  const { user } = useAuth();

  function capitalizeFirstLetter(str) {
    if (str.length === 0) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  const uname = capitalizeFirstLetter(user?.username);

  return (
    <Drawer
      variant="permanent"
      sx={{
        // backgroundColor: "green",
        // width: 50,
        width: !open ? 55 : null,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: !open ? 55 : null,
          // backgroundColor: "green",
        },
      }}
      open={open}
    >
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: [1],
        }}
      >
        <Link
          to="/Dashboard"
          className="cursor-pointer flex flex-row items-center"
        >
          <span className="cursor-pointer">
            <img src="/assets/logo.png" alt="Logo" width={40} height={40} />
          </span>
          <span className={[classes.heading]}>{uname}</span>
        </Link>
        <IconButton onClick={toggleDrawer}>
          <ChevronLeftIcon />
        </IconButton>
      </Toolbar>
      <Divider />
      <Sidebar />
    </Drawer>
  );
}
